import React from 'react';
import { Modal, Form, Select } from 'antd';

const UpdateBulkClient = ({
                              open,
                              loading,
                              clients = [],
                              selectedRowKeys = [],
                              bulkClientId,
                              setBulkClientId,
                              onCancel,
                              onOk,
                          }) => {
    return (
        <Modal
            title="Change client for selected devices"
            open={open}
            onCancel={onCancel}
            onOk={onOk}
            okText="Save"
            cancelText="Cancel"
            confirmLoading={loading}
        >
            <Form layout="vertical">
                <Form.Item
                    label="New client"
                    required
                >
                    <Select
                        showSearch
                        optionFilterProp="children"
                        placeholder="Select a client"
                        value={bulkClientId}
                        onChange={setBulkClientId}
                    >
                        {clients.map((client) => (
                            <Select.Option key={client._id} value={client._id}>
                                {client.name}
                            </Select.Option>
                        ))}
                    </Select>
                </Form.Item>

                <div style={{ marginTop: 8 }}>
                    Selected devices: <strong>{selectedRowKeys.length}</strong>
                </div>

                <div style={{ marginTop: 8, color: '#999' }}>
                    Changing the client will remove the current DeviceConfig assignment and reset LastConfigFetch.
                </div>
            </Form>
        </Modal>
    );
};

export default UpdateBulkClient;